import { locationListTypeValues } from '@/configuration/pages/ConfigurationPage/LogisticsConfiguration/DeliveryMethods/DeliveryMethodDetailConfiguration/constants'

export const locationListTypeOptions = [
  {
    label: 'URL listado tiendas',
    value: locationListTypeValues.url,
  },
  {
    label: 'Ubicaciones',
    value: locationListTypeValues.locations,
  },
]
